import { gql } from "graphql-tag";
import { useTesQuery } from "./useTesQuery";

const GET_SHIPPING_METADATA_QUERY = gql`
  query GetShippingMetadata($shippingId: String!) {
    shipping_metadatas(
      pagination: { limit: 10, orderBy: "id", orderDirection: "DESC" }
      filter: { shipping_id: { eq: $shippingId } }
    ) {
      items {
        created_at
        id
        key
        shipping_id
        updated_at
        value
      }
    }
  }
`;

export const useGetShippingMetadata = (shippingId, key = "label_url") => {
  const { data, isLoading, error } = useTesQuery(
    GET_SHIPPING_METADATA_QUERY,
    { shippingId, key },
    {
      queryKey: ["shipping-metadata", shippingId, key],
      enabled: !!shippingId,
      staleTime: 5 * 60 * 1000, // 5 minutes
      cacheTime: 10 * 60 * 1000, // 10 minutes
    }
  );

  return {
    data: data?.data?.shipping_metadatas?.items || [],
    isLoading,
    error,
  };
};
